export enum Status {
  NEW = "new",
  IN_PROGRESS = "inprogress",
  SUCCESS = "success",
  FAIL = "fail",
}
